module.exports = __webpack_public_path__ + "img/81.f5fe156b.png";